import {useEffect, useRef, useState} from "react";
import useCanvas from "./useCanvas";

import {Color, Solver} from "../helper";
import {createElementImage, initDevice, reportEvent} from "../../../../../utils";
import {EVENT_TRACER, keyswordsBack, keyswordsFront} from "../../../../../constants";
import {Stream} from "../../helpers/Stream";
import {documentValidator} from "../../../../../services/documentValidator";
import {getConstraints, getConstraintsIos} from "../../helpers";


export const PX_BORDER = '5px'
let imgCropped = 'no image'
let worker
let CONFIG
let TIME_TO_CAPTURE_MANUAL = 20
let TIME_TO_CHANGE_MESSAGE_ERROR = 2000
const PADDING_VERTICAL_TEXT_FRONT = 30
const SIZE_USER_MARK = 100
const SIZE_BAR_CODE = 78
const PADDING_WIDTH_TEXT_FRONT = 30
const PADDING_WIDTH_TEXT_BACK = 40
const PADDING_TEXT = 12
const PADDING_LEFT_TEXT_FRONT = 28 + PADDING_TEXT
const PADDING_RIGHT_TEXT_BACK = 54 + PADDING_TEXT
const PADDING_LEFT_TEXT_FRONT_TAKE_MANUAL = PADDING_LEFT_TEXT_FRONT + 4
export function isMovil() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
let timer
export default function useCamera() {
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });
    const {getFaces} = useCanvas(showStep)
    const [loading, setLoading] = useState(true)
    const [cameraIsReady, setCameraIsReady] = useState(false);
    const [isImageValidate, setImageValidate] = useState(false)
    const [typeCapture, setTypeCapture] = useState('')
    const [ocr, setOcr] = useState('')
    const [isCard, setIsCard] = useState('')
    const videoRef = useRef(null);
    const videoInitRef = useRef(null);
    const canvasRef = useRef(null);
    const finished = useRef(null);
    const initProcess = useRef(null);
    const canvasPreviewRef = useRef(null);
    const canvasCroppedImageRef = useRef(null);
    const firstCapture = useRef(true);
    const timerRef = useRef(0);
    const markRef = useRef(null);
    const renderGuide = useRef(true);
    const takeOneManualPhoto = useRef(true);
    const [capturedImageBack, setCapturedImageBack] = useState(null);
    const [step, setStep] = useState('');
    const [indicatorRotate, setIndicatorRotate] = useState(true);
    const [stepHistory, setStepHistory] = useState([]);
    const [seconds, setSeconds] = useState(0);
    const urlTracer = params.urlTracer
    const processId = params.processId

    const captured = useRef(false);
    function rotateBase64Image(base64Image) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const width = img.width;
                const height = img.height;

                const originalCanvas = document.createElement('canvas');
                originalCanvas.width = width;
                originalCanvas.height = height;

                const contextOriginal = originalCanvas.getContext('2d');
                contextOriginal.drawImage(img, 0, 0, originalCanvas.width, originalCanvas.height);

                const rotatedCanvas = document.createElement('canvas');
                rotatedCanvas.width = height;
                rotatedCanvas.height = width;
                const rotatedContext = rotatedCanvas.getContext('2d');
                rotatedContext.translate(0, width);
                rotatedContext.rotate(-Math.PI / 2);
                rotatedContext.drawImage(originalCanvas, 0, 0);

                resolve(rotatedCanvas.toDataURL('image/jpeg'));
            };
            img.onerror = reject;
            img.src = base64Image;
        });
    }

    function onRotateImage() {
        const video = videoRef.current;
        const width = video.videoWidth;
        const height = video.videoHeight;

        const originalCanvas = document.createElement('canvas');
        originalCanvas.width = width;
        originalCanvas.height = height;

        const contextOriginal = originalCanvas.getContext('2d');
        contextOriginal.drawImage(video, 0, 0, originalCanvas.width, originalCanvas.height);

        const rotatedCanvas = document.createElement('canvas');
        rotatedCanvas.width = height;
        rotatedCanvas.height = width;
        const rotatedContext = rotatedCanvas.getContext('2d');
        rotatedContext.translate(0, width);
        rotatedContext.rotate(-Math.PI / 2);
        rotatedContext.drawImage(originalCanvas, 0, 0);

        return rotatedCanvas.toDataURL('image/jpeg');
    }
    async function callbackAutoCapturing(image) {
        if (!captured.current) {
            const guideAdo = document.getElementById('guide-user-ado')
            if (guideAdo) {
                guideAdo.style.border = `${PX_BORDER} solid #15f51e`
            }
            captured.current = true;
            const streamRef = Stream.getInstance()
            streamRef.dropStream()
            clearInterval(timer)
            const imageRotated = await rotateBase64Image(image);
            setTimeout(() => {
                responseToHost(1, imageRotated, imageRotated)
            }, 1000)
        }
    }
    async function onReportEvent(eventType, message = '') {
        if (!urlTracer) return
        try {
            const response = await reportEvent(urlTracer, processId, eventType, message)
            console.log('response onReportEvent', response);
        } catch (e) {
            console.log('error report event', e.message)
        }
    }

    function initTimer() {
        timer = setInterval(() => {
            timerRef.current = timerRef.current + 1
            setSeconds(prevState => prevState + 1)
        }, 1000);
    }
    function resizeBase64(base64, newWidth, newHeight, quality) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = newWidth;
                canvas.height = newHeight;

                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, newWidth, newHeight);

                canvas.toBlob(
                    (blob) => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            resolve({
                                blob,
                                base64: reader.result
                            });
                        };
                        reader.onerror = reject;
                        reader.readAsDataURL(blob);
                    },
                    'image/jpeg',
                    quality
                );
            };
            img.onerror = reject;
            img.src = base64;
        });
    }
    async function startCameraDesktop(currentTypeCapture) {
        const constraintsDesktop = {
            video: true
        };
        videoRef.current.srcObject = await navigator.mediaDevices.getUserMedia(constraintsDesktop);

        await captureImage(currentTypeCapture)
    }
    function configUI(currentType) {
        // SHOW OR HIDDEN WATERMARKS
        if (currentType !== 1) {
            const barCodeMark = document.getElementById('preview-bar-mark')
            barCodeMark.style.display = CONFIG?.cardCapture?.watermarks?.showBack !== true ? 'none' : 'block'
            const textPreviewBack = document.getElementById('preview-text-mark-back')
            textPreviewBack.style.display = 'block'


        } else {
            const userMark = document.getElementById('preview-user-mark')
            // userMark.style.display = CONFIG?.cardCapture?.watermarks?.showFront !== true ? 'none' : 'block'
            const textPreview = document.getElementById('preview-text-mark')
            textPreview.style.display = 'block'
        }

        // SHOW GUIDE ADO
        const guideAdo = document.getElementById('guide-user-ado')
        guideAdo.style.display = 'flex'

        const imgBack = document.getElementById('img-back-ado')
        imgBack.style.display = CONFIG?.cardCapture?.closeIcon?.show !== true ? 'none' : 'block'
    }

    function showGuide(show) {
        const guide = document.getElementById('guide-user-ado');
        const imageBack = document.getElementById('img-back-ado');
        const takeManual = document.getElementById('take-photo-ado');
        const cameraVideo = document.getElementById('video-camera');
        guide.style.display = show ? 'flex' : 'none'
        imageBack.style.display = show ? CONFIG?.cardCapture?.closeIcon?.show !== true ? 'none' : 'block' : 'none'
        takeManual.style.display = show ? 'flex' : 'none'
        cameraVideo.style.display = show ? 'block' : 'none'
    }
    function changeGuideToDanger() {
        const guide = document.getElementById('guide-user-ado');
        const textPreviewUser = document.getElementById('preview-text-mark')
        const textPreviewBack = document.getElementById('preview-text-mark-back')

        if (guide) {
            guide.style.border = `${PX_BORDER} solid #FA7D87`;
            // parte trasera
        }
        if (textPreviewUser) {
            textPreviewUser.innerText = 'Verifica que tu documento se pueda leer claramente.'
            textPreviewUser.style.backgroundColor = "#FA7D87"
            textPreviewUser.style.color = "#2B3550"

            setTimeout(() => {
                console.log('CONFIG', CONFIG);
                textPreviewUser.innerText = CONFIG?.cardCapture?.messages?.messageFrontTimeout || 'Úbica la parte de adelante tu documento y toma la foto'
                textPreviewUser.style.backgroundColor = CONFIG.colors.background || 'rgb(54,54,54)'
                textPreviewUser.style.color = "#fff"
                if (guide) {
                    guide.style.border = `${PX_BORDER} solid ${CONFIG.colors.faceArea}`
                }
            }, TIME_TO_CHANGE_MESSAGE_ERROR)
        }
        if (textPreviewBack) {
            textPreviewBack.innerText = 'Verifica que tu documento se pueda leer claramente.'
            textPreviewBack.style.backgroundColor = "#FA7D87"
            textPreviewBack.style.color = "#2B3550"

            setTimeout(() => {
                textPreviewBack.style.backgroundColor = CONFIG.colors.background || 'rgb(54,54,54)'
                textPreviewBack.style.color = "#fff"
                textPreviewBack.innerText = CONFIG?.cardCapture?.messages?.messageBackTimeout || 'Úbica la parte de atrás de tu cédula y toma la foto'
                if (guide) {
                    guide.style.border = `${PX_BORDER} solid ${CONFIG.colors.faceArea}`
                }
            }, TIME_TO_CHANGE_MESSAGE_ERROR)
        }
    }
    async function takeManualPhoto() {
        onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureInitCaptureManual, 'Ha entrado en captura manual').catch()
        if (!takeOneManualPhoto.current) {
            console.log('takeOneManualPhoto.current')
            return
        }
        takeOneManualPhoto.current = false
        const alertAdo = document.getElementById('message-alert-ado');
        showGuide(false)
        try {
            setLoading(true)
            const isLandscape = window.matchMedia("(orientation: landscape)").matches;
            const canvas = canvasRef.current;
            const imageRotated = onRotateImage();
            if (isLandscape) {
                const imageOriginalResized = await resizeBase64(imageRotated, canvas.width, canvas.height, 0.5)
                const response = await documentValidator(imageOriginalResized.blob)
                setLoading(false)
                if (response.quality) {
                    onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureTakePhoToManual, 'El usuario a tomado una foto manual').catch()
                    responseToHost(isFront === 'true' ? 1 : 2, imageOriginalResized.base64, imageRotated)
                } else {
                    changeGuideToDanger()
                    showGuide(true)
                    takeOneManualPhoto.current = true
                }
            } else {
                const imageResized = await resizeBase64(imageRotated, canvas.height, canvas.width, 0.5)
                const response = await documentValidator(imageResized.blob)
                setLoading(false)
                if (response.quality) {
                    onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureTakePhoToManual, 'El usuario a tomado una foto manual').catch()
                    responseToHost(isFront === 'true' ? 1 : 2, imageResized.base64, imageRotated)
                } else {
                    changeGuideToDanger()
                    showGuide(true)
                    takeOneManualPhoto.current = true
                }
            }
        } catch (e) {
            console.log('takeManualPhoto error', e)
            responseToHostError(isFront === 'true' ? 'Frontal' : 'Trasera', e.message)
        }
    }
    async function startCamera(cameraType) {
        const constrains = getConstraints(initDevice().isMac, 'environment');
        const constrainsIos = getConstraintsIos('environment');
        try {
            let selectedCameraId;
            const stream = await navigator.mediaDevices.getUserMedia(initDevice().isIos ? constrainsIos : constrains)
            let currentStream = stream
            let constraintsMovil = constrains
            if (initDevice().isAndroid || initDevice().isIos) {
                const devices = await navigator.mediaDevices.enumerateDevices();
                let videoInputs = []
                if (initDevice().isIos) {
                    videoInputs = devices.filter(device => device.kind === 'videoinput' && (device.label.includes('Cámara trasera') || device.label.includes('Back Triple Camera') || device.label.includes('Back Camera')));
                } else if (initDevice().isAndroid) {
                    videoInputs = devices.filter(device => device.kind === 'videoinput' && (device.label.includes('facing back') && device.label.includes('0')));
                }

                if(videoInputs.length <= 0) {
                    videoInputs = devices.filter(device => device.kind === 'videoinput'
                        && device.label.includes('facing back'));
                }
                if (videoInputs.length > 0) {
                    selectedCameraId = videoInputs[0]?.deviceId
                    constraintsMovil = {
                        video: {
                            deviceId: { exact: selectedCameraId },
                            width: { ideal: initDevice().isIos ? 1920 : 1920 }, // 1920
                            height: { ideal: initDevice().isIos ? 1920 : 1080 }, // 1080,
                            // zoom: initDevice().isIos ? 1.5 : 1,
                            advanced: [
                                { focusMode: "continuous" }
                            ]
                        }
                    }
                    if (!selectedCameraId) delete constraintsMovil.video.deviceId
                    stream.getVideoTracks()[0].stop()
                    currentStream = await navigator.mediaDevices.getUserMedia(constraintsMovil)
                }
            }

            videoRef.current.srcObject = currentStream;
            videoInitRef.current = currentStream

            setTimeout(async () => {
                const video = videoRef.current;
                const canvas = canvasRef.current;
                const canvasContext = canvas.getContext('2d');
                canvasContext.imageSmoothingEnabled = true
                video.muted = true;
                video.srcObject = currentStream;
                onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureCameraOpen, 'Camara del card capture iniciada').catch()
                const streamRef = Stream.getInstance(initDevice(), '/models', true)
                streamRef.updateHtmlElements(videoRef.current, canvasRef.current)
                streamRef.setFaceDetection(true);
                streamRef.setCallbackAutoCapturing(callbackAutoCapturing)
                streamRef.setCallbackFaceDetectionErrors(() => {
                    const guideAdo = document.getElementById('guide-user-ado')
                    if (guideAdo && takeManualCaptured.current === false) {
                        guideAdo.style.border = `${PX_BORDER} solid #ed0050`
                    } else {
                        guideAdo.style.border = `${PX_BORDER} solid ${CONFIG.colors.faceArea}`
                    }
                })
                await getConfig()
                initTimer()
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                configUI(cameraType)
                const guideAdo = document.getElementById('guide-user-ado')
                guideAdo.style.transform = 'scale(1)'
                setLoading(false)
                await streamRef.startDetection()
            }, 1000)

        } catch (error) {
            console.log('err', error)
            onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureCameraError, error.message).catch()
            setLoading(false)
            responseToHostError(cameraType, error.message)
        }
    }

    function stopCamera() {
        try {
            const stream = videoRef.current.srcObject;
            const streamInit = videoInitRef.current.srcObject;
            if (stream) {
                const tracks = stream.getTracks();
                tracks.forEach(track => track.stop());
            }
            if (streamInit) {
                const tracks = streamInit.getTracks();
                tracks.forEach(track => track.stop());
            }
            videoRef.current.srcObject = null;
            videoInitRef.current.srcObject = null;
        } catch (e) {
            console.log('error stopCamera', e)
        }
    }


    function showStep(message, show= true) {
        if (show) {
            setStepHistory(prevState => [...prevState, message])
            setStep(message)
        }
    }

    function isPlatformIOS() {
        return /(iPhone|iPad|iPod)/.test(navigator.userAgent)
    }

    async function captureImage(type) {
        showStep(`Capture image ${type}`)
        const video = videoRef.current;
        const canvas = canvasRef.current;

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const context = canvas.getContext('2d');
        context.drawImage(video, 0, 0, canvas.width, canvas.height);

        const capturedDataUrl = canvas.toDataURL('image/jpeg');
        showStep('Image to data url')
        const imgElement = await createElementImage(capturedDataUrl);

        const imagebase64 = capturedDataUrl

        if (type === 1) {

            let imageToResponse = imagebase64
            setTimeout(async () => {
                const hasFaces = await getFaces(imgElement)
                if (!hasFaces.haarFace) {
                    setImageValidate(false)
                    imgElement.remove()
                    showStep('captureImage 1', true)
                    await captureImage(1)
                    return
                }
                setImageValidate(true)
                setCameraIsReady(false)
                const isOcr = await validateOCR(imagebase64, keyswordsFront);
                if (!isOcr) {
                    // setOcr('No')
                    await captureImage(1)
                    return
                }
                setOcr('Si')

                responseToHost(type, imageToResponse)
            }, 200)
        } else {
            setTimeout(async () => {
                const isOcr = await validateOCR(imagebase64, keyswordsBack);
                if (!isOcr) {
                    setOcr('No')
                    await captureImage(2)
                    return
                }
                setOcr('Si')
                setCameraIsReady(false)
                responseToHost(type, imagebase64)
            }, 200)
        }
    }

    const platform = params.platform || 'web'
    function checkKeywords(text, keywords) {
        const words = keywords.toLowerCase().split(' ');
        const lowerText = text.replace(/[^a-zA-Z0-9-\s]/g, "").toLowerCase();
        for (const word of words) {
            if (lowerText.includes(word)) {
                return true;
            }
        }
        return false;
    }

    function responseToHost(type, image, imageCropped) {
        console.log('image', image)
        console.log('imageCropped', imageCropped)
        clearInterval(timer)
        showStep("responseToHost")
        finished.current = true

        const cameraDoc = document.getElementById('video-camera')
        if (cameraDoc) {
            cameraDoc.style.display = 'none'
        }
        const guideAdo = document.getElementById('guide-user-ado')
        if (guideAdo) {
            guideAdo.style.display = 'none'
        }
        const userMark = document.getElementById('preview-bar-mark')
        if (userMark) {
            userMark.style.display = 'none'
        }
        const textPreviewUser = document.getElementById('preview-text-mark')
        if (textPreviewUser) {
            textPreviewUser.style.display = 'none'
        }

        const textPreviewBack = document.getElementById('preview-text-mark-back')
        if (textPreviewBack) {
            textPreviewBack.style.display = 'none'
        }
        const barCodeMark = document.getElementById('preview-user-mark')
        if (barCodeMark) {
            barCodeMark.style.display = 'none'
        }
        stopCamera()
        if (debug === 'true') {
            const imageref = document.getElementById("imgResult");
            imageref.src = imageCropped
            imageref.style.display = 'block'
            const videoContainerRef = document.getElementById("container-ado-camera");
            if (videoContainerRef) {
                videoContainerRef.style.display = 'none'
            }
            const btnBack = document.getElementById("img-back-ado");
            btnBack.style.display = 'none'

        }

        onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureResponseToHost, 'El servicio emitio al host').catch()
        if (platform === 'ios') {
            window.webkit.messageHandlers.messageHandlersName.postMessage(JSON.stringify({
                type: 'success',
                step: type === 1 ? 'frontCapture' : 'backCapture',
                data: image,
                cropped: image
            }));
            return;
        }

        if (platform === 'android') {
            window.ResponseAdo.handleEvent(JSON.stringify({
                type: 'success',
                step: type === 1 ? 'frontCapture' : 'backCapture',
                data: image,
                cropped: image
            }));
            return
        }

        if (platform === 'react-native') {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'success',
                step: type === 1 ? 'frontCapture' : 'backCapture',
                data: image,
                cropped: image
            }))
            return
        }
        window.parent.postMessage(
            JSON.stringify({
                type: 'success',
                step: type === 1 ? 'frontCapture' : 'backCapture',
                data: image,
                cropped: image
            }),
            '*'
        );
    }
    function responseToHostError(type, message) {
        finished.current = true

        const cameraDoc = document.getElementById('video-camera')
        if (cameraDoc) {
            cameraDoc.style.display = 'none'
        }
        const guideAdo = document.getElementById('guide-user-ado')
        if (guideAdo) {
            guideAdo.style.display = 'none'
        }
        const userMark = document.getElementById('preview-bar-mark')
        if (userMark) {
            userMark.style.display = 'none'
        }
        const textPreviewUser = document.getElementById('preview-text-mark')
        if (textPreviewUser) {
            textPreviewUser.style.display = 'none'
        }
        const textPreviewBack = document.getElementById('preview-text-mark-back')
        if (textPreviewBack) {
            textPreviewBack.style.display = 'none'
        }
        const barCodeMark = document.getElementById('preview-user-mark')
        if (barCodeMark) {
            barCodeMark.style.display = 'none'
        }
        stopCamera()
        onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureResponseToHost, message).catch()
        if (platform === 'ios') {
            window.webkit.messageHandlers.messageHandlersName.postMessage(JSON.stringify({
                type: 'failure',
                step: message,
                data: '',
            }));
            return;
        }

        if (platform === 'android') {
            window.ResponseAdo.handleEvent(JSON.stringify({
                type: 'failure',
                step: message,
                data: ''
            }));
            return
        }
        if (platform === 'react-native') {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'failure',
                step: message,
                data: ''
            }))
            return
        }
        window.parent.postMessage(
            JSON.stringify({
                type: 'failure',
                step: message,
                data: '',
            }),
            '*'
        );
    }
    async function validateOCR(image, keywords, type, imgElement) {
        return new Promise(async (resolve, reject) => {
            showStep('Init validate OCR')
            try {
                const { data: { text } } = await worker.recognize(image);
                setOcr(text)

                const includesKeyword = checkKeywords(text, keywords);
                resolve(includesKeyword)

            } catch (error) {
                // showStep(`Error -> ${error.message}`)
                console.log('error isCard', error)
                reject(error)

            }
        })
    }

    function goBack() {
        setOcr('clicked back')
        if (platform === 'ios') {
            window.webkit.messageHandlers.messageHandlersName.postMessage(JSON.stringify({
                type: 'success',
                step: 'back',
                data: '',
            }));
            return;
        }

        if (platform === 'android') {
            window.FinishClose.goBack();
            return
        }
        if (platform === 'react-native') {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'success',
                step: 'back',
                data: '',
            }))
            return
        }
        window.parent.postMessage(
            JSON.stringify({
                type: 'success',
                step: 'back',
                data: '',
            }),
            '*'
        );
    }

    const isFront = params.isFront || 'true'
    const debug = params.debug || 'false'
    const projectName = params.projectName || 'default'
    const urlServiceLiveness = params.urlServiceLiveness || 'https://vsts-liveness-bknd-dev.ado-tech.com'

    function generateFilterValue(hexColor) {
        // Verificar si el valor hexadecimal es válido
        if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hexColor)) {
            throw new Error('Valor hexadecimal no válido.');
        }

        // Remover el signo '#' si está presente
        hexColor = hexColor.replace('#', '');

        // Separar el valor en componentes (rojo, verde, azul)
        let r, g, b;

        if (hexColor.length === 3) {
            r = parseInt(hexColor[0] + hexColor[0], 16);
            g = parseInt(hexColor[1] + hexColor[1], 16);
            b = parseInt(hexColor[2] + hexColor[2], 16);
        } else {
            r = parseInt(hexColor.slice(0, 2), 16);
            g = parseInt(hexColor.slice(2, 4), 16);
            b = parseInt(hexColor.slice(4, 6), 16);
        }

        // Calcular los valores de filtro
        const invertValue = `${100 - (r / 255 * 100)}%`;
        const sepiaValue = `${(g / 255 * 100)}%`;
        const saturateValue = `${r / 255 * 6000}%`;
        const hueRotateValue = `${(g / 255 * 360)}deg`;
        const brightnessValue = `${(b / 255 * 200)}%`;
        const contrastValue = `${(g / 255 * 200)}%`;

        // Construir la cadena de filtro
        const filterValue = `invert(${invertValue}) sepia(${sepiaValue}) saturate(${saturateValue}) hue-rotate(${hueRotateValue}) brightness(${brightnessValue}) contrast(${contrastValue})`;

        return filterValue;
    }
    function hexToRgb(hex) {
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, (m, r, g, b) => {
            return r + r + g + g + b + b;
        });

        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result
            ? [
                parseInt(result[1], 16),
                parseInt(result[2], 16),
                parseInt(result[3], 16),
            ]
            : null;
    }
    function generateFilterValue2(hexColor) {
        const rgb = hexToRgb(hexColor)
        const color = new Color(rgb[0], rgb[1], rgb[2]);
        const solver = new Solver(color);
        return solver.solve()
    }
    async function getConfig() {
        try {
            const resp = await fetch(
                `${urlServiceLiveness}/api/configuration/${projectName}`,
                {
                    method: 'GET',
                }
            );
            const result = await resp.json();
            if (result.success) {
                const videoCameraRef = document.getElementById('video-camera')
                const imgBack = document.getElementById('img-back-ado')
                const textPreviewUser = document.getElementById('preview-text-mark')
                const textPreviewBack = document.getElementById('preview-text-mark-back')
                const guideAdo = document.getElementById('guide-user-ado')

                const colors = result?.data?.colors
                const configCardCapture = result?.data?.cardCapture
                TIME_TO_CAPTURE_MANUAL = configCardCapture.timeout
                CONFIG = result.data

                if (configCardCapture){
                    if (configCardCapture.colors) {
                        if (textPreviewUser) {
                            textPreviewUser.style.backgroundColor = configCardCapture.colors.background
                            textPreviewUser.style.color = configCardCapture.colors.color
                        }
                        if (textPreviewBack) {
                            textPreviewBack.style.backgroundColor = configCardCapture.colors.background
                            textPreviewBack.style.color = configCardCapture.colors.color
                        }

                    }

                    if (configCardCapture.messages) {
                        if (textPreviewUser) {
                            textPreviewUser.innerText = configCardCapture.messages.messageFront
                            textPreviewUser.style.fontFamily = configCardCapture.messages.fontFamily
                            textPreviewUser.style.fontSize = configCardCapture.messages.fontSize
                        }
                        if (textPreviewBack) {
                            textPreviewBack.innerText = configCardCapture.messages.messageBack
                            textPreviewBack.style.fontFamily = configCardCapture.messages.fontFamily
                            textPreviewBack.style.fontSize = configCardCapture.messages.fontSize
                        }
                    }

                    if (configCardCapture?.closeIcon) {
                        if (imgBack) {
                            // imgBack.style.display = configCardCapture?.closeIcon?.show !== true ? 'none' : 'block'
                            if (configCardCapture?.closeIcon?.url && isMovil()) {
                                imgBack.insertAdjacentHTML("afterbegin", `<img alt="img-back" style="width: 100%" src="${configCardCapture?.closeIcon?.url}"/>`)
                                imgBack.style.height = `${configCardCapture?.closeIcon?.size || '30px'}`
                                imgBack.style.width = `${configCardCapture?.closeIcon?.size || '30px'}`
                            } else {
                                imgBack.innerText = "X"
                                imgBack.style.fontSize = `${configCardCapture?.closeIcon?.size || '30px'}`
                                imgBack.style.color = `${configCardCapture?.closeIcon?.color || 'white'}`
                            }
                        }
                    }

                }

                if (!isMovil()) {
                    videoCameraRef.style.border = `${PX_BORDER} solid ${colors.faceArea}`
                } else {
                    guideAdo.style.border = `${PX_BORDER} solid ${colors.faceArea}`
                }
            }
        } catch (e) {
            console.log('error', e)
        }
    }
    useEffect(() => {
        if (projectName && !isMovil()) {
            getConfig().catch()
        }
    }, [projectName])

    useEffect(() => {
        const timer = setTimeout(() => {
        if (!initProcess.current) {
            initProcess.current = true
            if (isFront === 'true' || isFront === 'true/') {
                setTypeCapture('1')
                isMovil() ? startCamera(1).catch() : startCameraDesktop(1).catch()
            } else {
                setTypeCapture('2')
                isMovil() ? startCamera(2).catch() : startCameraDesktop(2).catch()
            } 
        }
        }, 100);
        return () => clearTimeout(timer);
    }, [])
    const takeManualCaptured = useRef(false);
    if (timerRef.current === TIME_TO_CAPTURE_MANUAL && isMovil() && !takeManualCaptured.current) {
        const streamRef = Stream.getInstance()
        streamRef.dropStream()
        const takePhotoRef = document.getElementById('take-photo-ado')
        takePhotoRef.style.display = 'flex'
        takeManualCaptured.current = true
        const guideAdo = document.getElementById('guide-user-ado')
        const textCaptureManual = document.getElementById('preview-text-mark')
        const textCaptureManualBack = document.getElementById('preview-text-mark-back')

        if (textCaptureManual) {
            textCaptureManual.innerText = CONFIG?.cardCapture?.messages?.messageFrontTimeout || 'Úbica la parte de adelante tu documento y toma la foto'
        }
        if (textCaptureManualBack) {
            textCaptureManualBack.innerText = CONFIG?.cardCapture?.messages?.messageBackTimeout || 'Úbica la parte de atrás de tu cédula y toma la foto'
        }

        if (guideAdo) {
            guideAdo.style.border = `${PX_BORDER} solid ${CONFIG.colors.faceArea}`
        }

        //textCaptureManual.style.top = `${((guideAdo.offsetHeight - PADDING_TEXT) - (textCaptureManual.offsetHeight / 2) - 12 ) / 2}px`
        // textCaptureManual.style.left = `-${(guideAdo.offsetHeight - (textCaptureManual.offsetHeight + PADDING_LEFT_TEXT_FRONT_TAKE_MANUAL)) / 2}px`

        // textCaptureManualBack.style.top = `${((guideAdo.offsetHeight - PADDING_TEXT) - (textCaptureManualBack.offsetHeight / 2) - 20 ) / 2}px`
        // textCaptureManualBack.style.left = '68%'
        clearInterval(timer)
    }

    return {
        videoRef,
        canvasRef,
        capturedImageBack,
        cameraIsReady,
        isCard,
        canvasPreviewRef,
        indicatorRotate,
        isImageValidate,
        canvasCroppedImageRef,
        ocr,
        debug,
        step,
        stepHistory,
        typeCapture,
        markRef,
        loading,
        projectName,
        isMovil,
        goBack,
        takeManualPhoto,
    }
}
